/**
 * Tramino Analytics
 *
 * Sammelt Ereignisse die im Frontend passieren und pusht diese zum Server.
 */

var _ = require('underscore');


/**
 * Client-Komponente für das Tramino Analytics System.
 *
 * @param $ {jQuery} jQuery Referenz
 */
var TraminoAnalytics = function($) {
	_.bindAll(this,
		"send",
		"sendEvents"
	);

	this.$ = $;
	this.api = (Tramino.ReservaAppRelease === 'staging' && navigator.userAgent.indexOf('Firefox') > 0 )
			   ? 'http://live.tramino.dev/analytics/push/'
			   : 'https://live.tramino.de/analytics/push/';
	this.dev = Tramino.ReservaAppRelease === 'staging';

	this.client = window.Tramino.client;
	this.page = window.Tramino.page;
	this.enabled = true;
};


/**
 * Ein Event an das Analytics-Backend senden. 
 * Events werden zwischengespeichert und in Paketen an den Server verschickt.
 *
 * @param betrieb {Number} ID des Betriebes/Clients
 * @param action {String} Name der Aktion ([a-z]+)
 */
TraminoAnalytics.prototype.send = function(betrieb, action) {
	var event = {
		betrieb: betrieb,
		action: action,
		page: this.page,
	};
	if ( !event.page && this.enabled ) {
		throw new Error("[TA] Event is missing a page (not defined in Analytics or window.Tramino)");
	}

	console.log("[TA] Event", event);
	this.sendEvents([event]);
};


/**
 * Events an den Server senden
 */
TraminoAnalytics.prototype.sendEvents = function(items) {
	if ( !this.enabled ) return;
	console.log("[TA] Pushing items to server " + this.api, items);

	var json = JSON.stringify({
		client: window.Tramino.client,
		items: items,
	});

	/* CORS is pretty broken on IE (Surprise!), so we use fake images */
	if ( navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident') !== -1 ) {
		console.log("[TA] Using image send method");
		var url = this.api + '?json=' + encodeURIComponent(json);

		var img = this.$('<img>');
		img[0].onload = function() {
			console.log("[TA] Image onload called");
			img.remove();
		};
		img[0].onerror = function(e) {
			console.log("[TA] Image onerror called");
			img.remove();
		};
		img.css({
			position: 'fixed',
			top: '-1000px',
			left: '-1000px',
			width: '1px',
			height: '1px',
		});
		img.attr('src', url);
	} else {
		console.log("[TA] Using AJAX GET method");

		this.$.ajax(this.api, {
			type: "GET",
			data: {
				json: json,
			},
			dataType: "json",
			success: function(response) {
				console.log("[TA] Response", response);
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log("[TA] Failure: (textStatus: " + textStatus + ") (errorThrown: " + errorThrown + ")");
			},
		});
	}
};

module.exports = TraminoAnalytics;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/analytics/main.js
 **/